/**
 * @format
 * @flow
 */
import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router';
import * as Actions from '../../../actions/Task';

import Template from '../../../components/Template/AfterLoginTemplate';
import TaskCardForDetail from '../../../components/Parts/TaskCardForDetail';
import Modal from '../../../components/Common/Modal';
import * as RT from '../../../constants/Routing';

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reward: 0,
      rewardText: 0,
      description: '',
      modalOpen: false,
      modalTitle: 'タスク情報を変更します'
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  componentWillUnmount = () => {
    this.props.taskEditReset();
  };

  componentWillMount = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.task_id;
    this.props.getTaskDetail(enterpriseId, token, taskId);
  };

  componentWillReceiveProps = next => {
    if (next.Task.taskDetailLoaded && !this.props.Task.taskDetailLoaded) {
      const task = next.Task.taskDetail;
      let approvedUsers = [];
      let activeUsers = [];
      let offerUsers = [];
      if (Object.keys(task).length > 0) {
        approvedUsers = task.approvalTask === null ? [] : task.approvalTask.filter(Boolean);
        activeUsers = task.completedTask === null ? [] : task.completedTask.filter(Boolean);
        offerUsers = task.offerTask === null ? [] : task.offerTask.filter(Boolean);
      }
      const activeTaskCount = approvedUsers.length + activeUsers.length + offerUsers.length;
      if (task.taskStatus !== 'currentTask' || activeTaskCount !== 0) {
        this.props.history.push(RT.TASK_SHOW_PATH.replace(/:task_id/, task.taskId));
      } else {
        this.setState({
          reward: Number(next.Task.taskDetail.fee) / 100,
          rewardText: Number(next.Task.taskDetail.fee),
          description: next.Task.taskDetail.description
        });
      }
    }
  };

  componentDidUpdate = _prevProps => {
    if (this.props.Task.taskEdited === true) {
      this.props.history.push(
        RT.TASK_SHOW_PATH.replace(/:task_id/, this.props.Task.taskDetail.taskId)
      );
    }
  };

  _setValue = e => {
    if (e.target.name === 'reward') {
      let rewardTextValue = `${e.target.value}00`;
      if (e.target.value === '') {
        rewardTextValue = '';
      }
      this.setState({
        [e.target.name]: e.target.value,
        rewardText: rewardTextValue
      });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  _sendEditAction = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.task_id;

    const params = {
      token,
      enterpriseId,
      taskId,
      fee: this.state.rewardText,
      description: this.state.description,
      // enterprise: this.props.Task.taskDetail.enterprise
      enterpriseName: this.props.Task.taskDetail.enterprise.enterpriseName,
      enterprisePhotoId: this.props.Task.taskDetail.enterprise.enterprisePhotoId,
      enterpriseCategory: this.props.Task.taskDetail.enterprise.enterpriseCategory
    };
    this.props.taskEditAction(params);
  };

  modalClose = () => {
    this.setState({ modalOpen: false });
  };

  editConfirm = () => {
    this.setState({ modalOpen: true });
  };

  render = () => {
    const task = this.props.Task.taskDetail;
    const confirmTask = { ...task };
    let approvedUsers = [];
    let activeUsers = [];
    let cancelUsers = [];
    let offerUsers = [];
    if (this.state.loaded) {
      if (Object.keys(task).length > 0) {
        approvedUsers = task.approvalTask === null ? [] : task.approvalTask;
        activeUsers = task.activeTask === null ? [] : task.activeTask;
        cancelUsers = task.cancelTask === null ? [] : task.cancelTask;
        offerUsers = task.offerTask === null ? [] : task.offerTask;
      }
    }
    const allEntryCount =
      approvedUsers.length + activeUsers.length + cancelUsers.length + offerUsers.length;

    return (
      <Template>
        <Modal
          isOpen={this.state.modalOpen}
          closeModal={() => this.setState({ modalOpen: false })}
          headerTitle={this.state.modalTitle}
          okClickHandler={null}
        >
          <div className="mt-5" />
          <TaskCardForDetail
            task={(() => {
              confirmTask.fee = this.state.rewardText;
              confirmTask.description = this.state.description;

              return confirmTask;
            })()}
            allEntryCount={allEntryCount}
            noImage
          />
          <div className="mt-5">
            <button onClick={this._sendEditAction} className="btn btn-primary float-right">
              はい
            </button>
            <button onClick={this.modalClose} className="btn btn-cancel float-right mr-3">
              いいえ
            </button>
          </div>
        </Modal>
        <div className="">
          <h2>タスクの編集</h2>
          <TaskCardForDetail task={task} />
          <div className="form-group">
            <label htmlFor="exampleInputEmail1" style={{ width: '100%' }}>
              報酬(交通費を含むタスクの報酬の合計を入力してください)
            </label>
            <input
              type="number"
              min="1"
              className="form-control"
              value={this.state.reward}
              defaultValue={this.state.reward}
              style={{
                width: '300px',
                display: 'inline-block',
                marginRight: '10px'
              }}
              onChange={this._setValue}
              name="reward"
            />
            <span>00円</span>

            <div className="task-line-form-wrap">
              <input
                type="text"
                className="form-control task-line-form"
                style={{ width: '300px' }}
                value={String(this.state.rewardText).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}
                name="rewardText"
              />
            </div>
          </div>

          <div className="row mt-5">
            <div className="form-group position-relative col-10">
              <label htmlFor="exampleInputPassword1">案件の説明文</label>
              <textarea
                type="password"
                className="form-control"
                style={{ height: '200px' }}
                name="description"
                onChange={this._setValue}
                value={this.state.description}
              />
            </div>
          </div>

          <div className="mt-4" style={{ textAlign: 'right' }}>
            <button className="btn btn-primary" onClick={this.editConfirm}>
              タスクの編集
            </button>
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
